import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import FloatingWa from './components/floatingWa';
import ScrollToTop from './components/ScrollToTop';

import HomePage from './pages/HomePage';
import IndividualWellnessPage from './pages/IndividualWellnessPage';
import CorporateWellnessPage from './pages/CorporateWellnessPage';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen bg-background font-sans text-foreground selection:bg-lotus-petal selection:text-lotus-deep flex flex-col justify-between">
        <div>
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/individual-wellness" element={<IndividualWellnessPage />} />
              <Route path="/corporate-wellness" element={<CorporateWellnessPage />} />
            </Routes>
          </main>
        </div>
        <div>
          <Footer />
          <FloatingWa />
        </div>
      </div>
    </Router>
  );
}

export default App;
